<template>
  <BaseDataList ref="dataList" :items="approvalClaims" :service="loadList" lazy>
    <template #custom-action>
      <ApprovalClaimCreateAction
        :project-asset="projectAsset"
        @approval-claim-created="onApprovalClaimCreated"
      />
    </template>

    <template #header>
      <ApprovalClaimListHeader />
    </template>

    <template #default="{ item }">
      <ApprovalClaimListItem
        :approval-claim="item"
        @approval-request-created="onApprovalRequestCreated"
        @approval-claim-deleted="onApprovalClaimDeleted"
      />
    </template>
  </BaseDataList>
</template>

<script>
import ApprovalClaimCreateAction from './ApprovalClaimCreateAction.vue';
import ApprovalClaimListHeader from './ApprovalClaimListHeader.vue';
import ApprovalClaimListItem from './ApprovalClaimListItem.vue';

export default {
  components: {
    ApprovalClaimListHeader,
    ApprovalClaimListItem,
    ApprovalClaimCreateAction,
  },
  props: {
    projectAsset: {
      type: Object,
      required: true,
    },
    approvalClaims: {
      type: Array,
      default: () => [],
    },
    loadList: {
      type: Function,
      required: true,
    },
  },
  methods: {
    onApprovalRequestCreated() {
      this.$refs.dataList.fetchList();
      this.$emit('approval-claim-list-changed');
    },
    onApprovalClaimCreated() {
      this.$refs.dataList.fetchList();
    },
    onApprovalClaimDeleted() {
      this.$refs.dataList.fetchList();
    },
  },
};
</script>
